<template>
  <div class="upload-video">
    <Spin v-if="videoLoading"
          size="large"
          style="position:absolute;top:40px;left:40px;"></Spin>
    <!-- 上传，限制张数 -->
    <div class="upload-list-new"
         v-for="(item,index) in videoList" :key="index">
      <template v-if="item.status === 'finished'">
        <img src="/playVideo.png" />
        <div class="upload-list-cover">
          <Icon type="ios-eye-outline"
                @click.native="handleView(item.name)"></Icon>
          <Icon type="ios-trash-outline"
                @click.native="handleRemove(item)"></Icon>
        </div>
      </template>
      <template v-else>
        <Progress v-if="item.showProgress"
                  :percent="item.percentage"
                  hide-info></Progress>
      </template>
      <Modal title="View Image"
             v-model="visible"
             style="text-align:center">
        <Video :src="item.fullurl"
               v-if="visible"
               style="max-width:100%;max-height:100%"
               controls
               footer-hide></Video>
      </Modal>
    </div>
    <!-- 上传，限制张数 -->
    <Upload ref="upload-video"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['mp4']"
            :max-size="5120000"
            :on-progress="handelProgress"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            :on-remove="handleRemove"
            name="imgFile"
            type="drag"
            :data="postData"
            accept="video/*"
            action="/common/upload/bigupload"
            style="display: inline-block;width:90px;"
            :class="{'display':!uploadStatus}">
      <div style="width: 90px;height:90px;line-height: 90px;">
        <Icon type="ios-film"
              size="20"></Icon>
      </div>
    </Upload>
    <Alert class="mt10"
           style="max-width:200px;margin-left: 10px;">上传视频格式为mp4，大小不超过5G，请自己处理好其它宽、高、清晰度问题</Alert>
    <div v-if="showUpload"
         style="margin-top: 20px;margin-left: 20px">
      文件: {{ file==null?'':file.name }}
      <Button type="primary"
              @click="uploadHs"
              :loading="loadingStatus">{{loadingStatus?'上传中':'点击上传'}}</Button>
      <!--            <Button type="success"  v-if="loadingStatus">{{ '上传中' }}</Button>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadVideo",
  data () {
    return {
      playTime: "",
      videoLoading: true,
      showUpload: false,
      // 已经上传成功的所有文件结果
      videoList: [],
      videoTime: "",
      postData: {
        thumb: 0,
        thumbWidth: "200px",
        thumbWidth: "200px"
      },
      uploadStatus: true,
      visible: false,
      loadingStatus: false,
      file: null
    };
  },
  props: {
    defaultList: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  mounted () {
    this.videoList = this.$refs["upload-video"].fileList;
  },
  watch: {
    defaultList (curVal, oldVal) {
      if (curVal) {
        this.videoList = curVal;
      }
      if (this.uploadStatus == true) {
        this.$refs["upload-video"].fileList = new Array();
        this.videoList = new Array();
      }
 console.log("videoList11111",this,videoList);
    }
  },
  created: function () { },
  methods: {
    uploadHs () {
      let that = this;
      that.loadingStatus = true;
      that.$forceUpdate();
      setTimeout(function () {
        that.upload();
      }, 300);
    },
    upload () {
      let that = this;
      that.loadingStatus = true;
      that.$forceUpdate();
      // console.log(that.loadingStatus);
      var LENGTH = 1024 * 1024 * 8; //每次上传的大小
      var totalSize = this.file.size; //文件总大小
      var start = 0; //每次上传的开始字节
      var end = start + LENGTH; //每次上传的结尾字节
      var blob = null; //二进制对象
      var fd = null; //创建表单数据对象
      var xhr = null; //xhr对象
      var response = null;
      while (start < totalSize) {
        fd = new FormData(); //每一次需要重新创建
        xhr = new XMLHttpRequest(); //需要每次创建并设置参数
        xhr.open("POST", "/common/upload/bigupload", false);
        blob = this.file.slice(start, end); //根据长度截取每次需要上传的数据
        //重新设置开始和结尾
        // console.log(fd);
        fd.append("video", blob); //添加数据到fd对象中
        fd.append("filename", this.file.name); //获取文件的名称
        if (end >= totalSize) {
          fd.append("is_last", 1);
        } else {
          fd.append("is_last", 0);
        }
        xhr.send(fd); //将fd数据上传
        response = JSON.parse(xhr.response);
        if (response.code != 200) {
          this.$Notice.warning({
            title: "上传失败",
            desc: "请检查网络及上传的内容是否符合要求！"
          });
          return;
        }
        start = end;
        end = start + LENGTH;
        // console.log('上传了文件');
      }
      console.log('上传完了');
      this.handleSuccess(response);
    },

    handleClearFiles () {
      // 再次点击上传之前，清空之前已上传文件
      this.$refs.upload.clearFiles();
    },
    // 移除的回调
    handleRemove (file) {
      console.log("handleRemove");
      this.uploadStatus = true;
      // console.log(file)
      const fileList = this.$refs["upload-video"].fileList;
      this.$refs["upload-video"].fileList.splice(fileList.indexOf(file), 1);
      this.defaultList.splice(fileList.indexOf(file), 1);
    },
    // 上传成功的回调
    handleSuccess (res) {
      console.log("handleSuccess");
      let that = this;
      this.loadingStatus = false;
      // console.log(this.loadingStatus);
      var file = {};
      if (res.code == 200) {
        this.videoLoading = false;
        // console.log(res.data)
        file.name = res.result.filename;
        file.url = res.result.url;
        file.fullurl = this.$publicData.ossUrl + res.result.url;
        file.status = "finished";
        this.$refs["upload-video"].fileList.push(file);
        this.uploadStatus = false;
        this.videoList = this.$refs["upload-video"].fileList;
        this.videoUrl = file.url;
        var video = document.createElement("video");
        video.src = file.fullurl;
        video.addEventListener = function () {
          that.videoTime = video.duration;
        };

        this.showUpload = false;
      } else {
        this.videoLoading = false;
        this.$Notice.warning({
          title: "上传失败",
          desc: "请检查网络及上传的内容是否符合要求！"
        });
      }
    },
    // 检查文件格式
    handleFormatError (file) {
      // console.log("handleFormatError");
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "文件 " + file.name + " 格式不正确, 请插入mp4格式的视频。"
      });
    },
    // 检查大小
    handleMaxSize (file) {
      // console.log("handleMaxSize");
      this.$Notice.warning({
        title: "文件大小超出限制",
        desc: "文件 " + file.name + " 太大，最大就不要超过5G！"
      });
    },
    handleView (name) {
      // console.log("handleView");
      this.imgName = name;
      this.visible = true;
    },
    handelProgress (event, file, fileList) {
      // console.log("handelProgress");
      this.videoList.push(file);
      event.target.onprogress = event => {
        let uploadPercent = parseFloat(
          ((event.loaded / event.total) * 100).toFixed(2)
        ); // 保留两位小数，具体根据自己需求做更改
        // 手动设置显示上传进度条 以及上传百分比
        file.showProgress = true;
        file.percentage = uploadPercent;
      };
    },
    // 上传前检查数量
    handleBeforeUpload (file) {
      let that = this
      // console.log("handleBeforeUpload");
      this.videoLoading = true;
      const check = this.videoList.length < 1;
      if (!check) {
        this.$Notice.warning({
          title: "已经超出最大可上传数量！"
        });
      } else {
        this.videoList = this.$refs["upload-video"].fileList;
      }
      this.file = file;
      this.showUpload = true;

      let url = URL.createObjectURL(file);
      var audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", function () {
        that.playTime = audioElement.duration; //playTime就是当前视频长度
        // console.log("playTime",this.playTime);
        that.setTime();
      });
      return false;
    },
    setTime () {
      // console.log('-------');
      // console.log(this.playTime);
      this.$emit("set_time", this.playTime);
    }
  }
};
</script>
<style>
.ivu-list-item .ivu-spin-main {
  display: none;
}
.upload-video {
  display: inline-flex;
}
.display {
  display: none !important;
}
.op {
  opacity: 0;
}
.upload-list-new {
  display: inline-block;
  width: 140px;
  height: 140px;
  text-align: center;
  line-height: 140px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.upload-list-new video {
  width: 100%;
  height: 100%;
}
.upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.upload-list-new:hover .upload-list-cover {
  /*display: block;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.pclass {
  color: #f00;
}
</style>

